import { LOCALE_ID, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { guardProviders } from './guards/guard-providers';
import { interceptorProviders } from './interceptors/interceptor-providers';
import { serviceProviders } from './services/service-providers';
import { SharedModule } from '@masar/shared/shared.module';
import { MnmWebappModule } from 'mnm-webapp';
import { MasarModule } from '@masar/features/masar/masar.module';
import { TranslationModule } from '@ng-omar/translation';
import { EasterModule } from '@masar/features/easter/easter.module';
import { translationConfig, mnmWebAppConfig } from '@masar/config';
import { registerLocaleData } from '@angular/common';
import localeAr from '@angular/common/locales/ar';
import { EvaluateModule } from '@masar/features/evaluate/evaluate.module';

registerLocaleData(localeAr, 'ar');

// Evaluated once: the library refuses a second forRoot() call, and Angular's
// dev-mode class metadata re-evaluates decorator arguments after the injector
// definition already ran them.
const translationModule = TranslationModule.forRoot(translationConfig);

@NgModule({
    imports: [
        TranslateModule,
        RouterModule,
        SharedModule.forRoot(),
        MnmWebappModule.forRoot(mnmWebAppConfig),
        MasarModule.forRoot(),
        TranslateModule.forRoot(),
        translationModule,
        EasterModule.forRoot(),
        EvaluateModule.forRoot(),
    ],
    providers: [
        { provide: LOCALE_ID, useValue: localStorage.getItem('lang') || 'ar' },
        guardProviders,
        interceptorProviders,
        serviceProviders,
    ],
})
export class CoreModule {}
